/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf


/**
 * The main Menu.
 *
 * @type {angular.Module}
 */
module partner {
  'use strict';

  var nav = angular.module('partner', ['ngMap', 'angular-cache'])
    .controller('PartnerCtrl', PartnerCtrl)
    .controller('PartnerFlagCtrl', PartnerFlagCtrl)
    .directive('vendorAddress', VendorAddressDirective)
    .directive('simpleVendorAddress', SimpleVendorAddressDirective)
    .service('partnerService', PartnerService);
}